import { render } from "./ResourceImage.vue?vue&type=template&id=2b6e483a"
import script from "./ResourceImage.vue?vue&type=script&lang=js"
export * from "./ResourceImage.vue?vue&type=script&lang=js"

import exportComponent from "/var/vhosts/unrisd-frontend/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__